<div class="row m-0 p-0 loading-parent" *ngIf="loadingImages">
    <div class="col-12 p-0 m-0">
        <div class="loading_general">
            <img class="animate__animated animate__flash animate__infinite animate__slow "
                src="assets\img\logos_cinemateca\SVG\logo_completo_blanco.svg" alt="Cinemateca" />
        </div>
    </div>
</div>

<div class="grid" [ngClass]="{'img-hidden': loadingImages}" #imagegrid>
    <div class="grid-item" *ngFor="let frame of Frames; let i = index">
        <img [src]="frame.pictureLinkFull" class="img-thumbnail" (click)="openModal(i)">
    </div>
</div>

<div class="no-frames-sign" *ngIf="noFrames">
    <span class="no-frames-sign__text">
        Aun no se han subido fotogramas.
    </span>
</div>


<div class="modal fade contenedor-modal" id="modalFrames" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content cm-bg-color-0">
            <div class="modal-body text-center">
                <img [src]="Frames[currentIndex].pictureLinkFull" class="img-fluid" *ngIf="!noFrames">
                <div class="h-100 w-100 d-flex flechitas-parent">
                    <div class="d-flex h-100 flechitas-distance">
                        <button class="btn btn-secondary flechita-prev" (click)="prevImage()">
                            &#9664;
                        </button>
                        <button class="btn btn-secondary" (click)="nextImage()">
                            &#9654;
                        </button>
                    </div>
                </div>
                <div class="h-100 w-100 close-parent">
                    <div class="d-flex close-button">
                        <button class="close cm-tx-color-11" (click)="closeModal()">Cerrar</button>
                    </div>
                </div>
            </div>
            <!-- <div class="modal-footer">
                <button class="close btn cm-tx-color-11" (click)="closeModal()">Cerrar</button>
                <button type="button" class="btn btn-secondary" (click)="prevImage()">Previous</button>
                    <button type="button" class="btn btn-secondary" (click)="nextImage()">Next</button>
            </div> -->
        </div>
    </div>
</div>